// extracted by mini-css-extract-plugin
export var cartContainer = "_ht-4";
export var gray = "_ht-1";
export var itemContainer = "_ht-2";
export var itemDetails = "_ht-3";
export var strong = "_ht-0";